import * as types from "../types";

const initialState = {
    regions: []
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_REGIONS:
            return { ...state, regions: action.payload };

        default:
            return { ...state };
    }
};

export default reducer;
